<template>
  <div class="animated fadeIn">
    <div class="mt-5 display-4 text-left">
      <span>Add Location</span>
    </div>
    <div v-if="customer_location">
      <b-card class="mt-3">
        <customer-location-form-group
          :customer_location="customer_location"
          @onCustomerLocationChange="onCustomerLocationChange"
        ></customer-location-form-group>
      </b-card>
      <div class="clearfix mb-5">
        <b-button variant="success" class="float-right" @click="saveLocation">Save</b-button>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomerLocationFormGroup from "../../components/auth/register/inner/CustomerLocationFormGroup";
  import CustomerLocationModel from "../../models/crm/CustomerLocationModel";

  export default {
    components: {CustomerLocationFormGroup},
    name: 'LocationAdd',
    data() {
      return {
        authenticated_customer_id: (this.$store.getters.getAuthCustomerID || null),
        customer_location: (new CustomerLocationModel())
      }
    },
    methods: {

      onCustomerLocationChange: function(customer_location) {
        this.customer_location.set(customer_location);
      },

      saveLocation: function() {
        this.customer_location.set('customer_id', this.authenticated_customer_id);
        this.customer_location.save().then(() => {
          this.$bvToast.toast('Thanks!', {
            title: 'Location created successfully',
            variant: 'success',
            autoHideDelay: 1000
          });
          setTimeout(() => { this.$router.push('/team') }, 1000)
        });
      },

    },
    mounted() {}
  }
</script>
